import React, { useEffect, useState } from "react";
import CustomContainer from "../../components/common/CustomContainer"
import { employeeEngagementApi } from "../../utils/api/services";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { RootState } from "../../utils/store";
import CustomPieChart from "../../components/common/CustomPieChart";
import XBarChart from "../../components/common/XBarChart";
import { FormGroup, FormLabel } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import moment from "moment";
import Loader from "../../components/common/Loader";
import { formatUnderscoreToUpper } from "../../utils/functions/common";

const Engagement = () => {
    const [overallEngagement, setOverallEngagement] = useState<PieDataTypes[]>([]);
    const [recurringChartData, setRecurringChartData] = useState<{ name: string, value: number }[]>([])
    const [uniqueChartData, setUniqueChartData] = useState<{ name: string, value: number }[]>([])
    const [filterData, setFilterData] = useState<filterTypes>({
        from_date: '',
        to_date: ''
    })
    const [loading, setLoading] = useState(false)
    const { LoginData } = useSelector((state: RootState) => state.auth);

    const handleDateFilters: HandleDateChangeType = (date, name) => {
        const formattedDate = moment(date).format('YYYY-MM-DD');
        if (!date) {
            setFilterData({ ...filterData, [name]: '' });
        }
        else {
            setFilterData({ ...filterData, [name]: formattedDate });
        }
    };

    const fetchEngagementData = async (data: { companyId: number, from_date?: string, to_date?: string }) => {
        try {
            setLoading(true)
            const result = await employeeEngagementApi(data);
            if (result?.success) {
                setLoading(false)
                const _engagement = result?.servicedetails as Engagement
                const NoOfEmpTaken = [
                    { name: "Total Employees", value: _engagement?.total, color: "#54a276" },
                    { name: "Not Taken Any Services", value: _engagement?.notTaken, color: "#aa2626" },
                ]
                setOverallEngagement(NoOfEmpTaken);
                const _recurringData = (_engagement?.recurring as RecurringEngagement[])?.map((item) => {
                    return {
                        name: formatUnderscoreToUpper(item?.name),
                        value: item?.count,
                    }
                })
                setRecurringChartData(_recurringData)
                const _uniqueData = (_engagement?.unique as UniqueEngagement[])?.map((item) => {
                    return {
                        name: formatUnderscoreToUpper(item?.name),
                        value: item?.count,
                    }
                })
                setUniqueChartData(_uniqueData)
            }
        } catch (error: any) {
            setLoading(false)
            toast.error(error?.data?.errors || error?.message);
        }
    }

    useEffect(() => {
        if (LoginData) {
            fetchEngagementData({ companyId: LoginData?.companyId, from_date: filterData?.from_date, to_date: filterData?.to_date })
        }
    }, [filterData])

    if (loading) {
        return <Loader />
    }
    return (
        <CustomContainer>
            <div className={'AllPageMain'}>
                <div className={'HeadAndButton'}>
                    <h2>Engagement</h2>
                </div>
                <div className="flex justify-end items-center gap-6">
                    <FormGroup className="customFormGroup">
                        <FormLabel className="customFormLabel">From Date</FormLabel>
                        <DatePicker
                            className="custumTextField profileInput"
                            value={filterData?.from_date ? moment(filterData?.from_date, 'YYYY-MM-DD') : null}
                            maxDate={moment(new Date(), 'YYYY-MM-DD')}
                            format="YYYY-MM-DD"
                            onChange={(date) => handleDateFilters(date ? moment(date)?.toDate() : null, 'from_date')}
                            slotProps={{ field: { clearable: filterData?.from_date ? true : false } }}
                        />
                    </FormGroup>
                    <FormGroup className="customFormGroup">
                        <FormLabel className="customFormLabel">To Date</FormLabel>
                        <DatePicker
                            className="custumTextField profileInput"
                            value={filterData?.to_date ? moment(filterData?.to_date, 'YYYY-MM-DD') : null}
                            minDate={moment(filterData?.from_date, 'YYYY-MM-DD')}
                            maxDate={moment(new Date(), 'YYYY-MM-DD')}
                            format="YYYY-MM-DD"
                            disabled={filterData?.from_date === "" ? true : false}
                            onChange={(date) => handleDateFilters(date ? moment(date)?.toDate() : null, 'to_date')}
                            slotProps={{ field: { clearable: filterData?.from_date ? true : false } }}
                        />
                    </FormGroup>
                </div>
                <div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-6">
                        <div className="md:col-span-2">
                            <CustomPieChart chartData={overallEngagement} title={"Overall engagement of employees"} />
                        </div>
                        <XBarChart chartData={recurringChartData} title="Recurring" />
                        <XBarChart chartData={uniqueChartData} title="Unique" />
                    </div>
                </div>
            </div>
        </CustomContainer>
    )
}

export default Engagement